import React from 'react'
import { Modal } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { planList } from '../../redux/slice/PlanList';
import { createOrder } from '../../redux/slice/CreateOrder';
import { verifyPayment } from '../../redux/slice/VerifyPayment';
import { linkList } from '../../redux/slice/LinkList';
import moment from 'moment';
import { toast } from 'react-toastify';
import '../../assets/css/PlanPage.css';
import Loader from '../../components/loader/Loader';
import { biolinkPlanList } from '../../redux/slice/BioLinkPlan';

export default function BiolinkSubscription(props) {
    const { show2, setShow2, bool, setBool } = props;
    const [loader, setLoader] = useState(false);
    const handleClose = () => setShow2(false);
    const dispatch = useDispatch();
    const data = useSelector((state) => state?.biolinkPlanList?.data?.[0]);
    const user = useSelector((state) => state.auth.user);
    const navigate = useNavigate()

    useEffect(() => {
        setLoader(true);
        dispatch(biolinkPlanList({ plan_type: 'biolink', navigate })).finally(() => setLoader(false));
    }, [show2]);

    // const handleBuyPlan = async (item) => {
    //     const price = parseFloat(item.price) || 0;
    //     if (price === 0) return;

    //     // Check if Razorpay is loaded
    //     if (!window.Razorpay) {
    //         toast.error('Razorpay is not loaded. Please refresh the page and try again.', { position: "bottom-right" });
    //         return;
    //     }

    //     try {
    //         // Create order first
    //         const orderResult = await dispatch(createOrder({
    //             plan_id: item._id
    //         }));

    //         if ((orderResult.payload?.status !== 200 && orderResult.payload?.status !== 201) || orderResult.payload?.data?.status !== true) {
    //             const errorMessage = orderResult.payload?.data?.message || 'Failed to create order';
    //             toast.error(errorMessage, { position: "bottom-right" });
    //             return;
    //         }

    //         const orderData = orderResult.payload?.data?.data;
    //         console.log(orderData, 'orderData')
    //         const orderId = orderData?.[0]?.razorpay_order_id || '';

    //         if (!orderId) {
    //             toast.error('Order ID not received from server', { position: "bottom-right" });
    //             return;
    //         }

    //         const options = {
    //             key: process.env.REACT_APP_RAZORPAY_KEY || 'YOUR_RAZORPAY_KEY_ID',
    //             amount: price * 100, // Amount in paise (multiply by 100 for rupees)
    //             currency: item.currency || 'INR',
    //             name: item.plan_name || item.name || 'Plan Purchase',
    //             description: item.description || `Purchase ${item.plan_name || item.name || 'Plan'}`,
    //             image: '', // Optional: Your logo URL
    //             order_id: orderId, // Use order_id from create_order API
    //             handler: async function (response) {
    //                 // Handle successful payment
    //                 console.log('Payment successful:', response);

    //                 try {
    //                     // Verify payment with backend
    //                     const verifyResult = await dispatch(verifyPayment({
    //                         razorpay_order_id: response.razorpay_order_id,
    //                         razorpay_payment_id: response.razorpay_payment_id,
    //                         razorpay_signature: response.razorpay_signature,
    //                         link_id: '',
    //                     }));

    //                     if ((verifyResult.payload?.status === 200 || verifyResult.payload?.status === 201) && verifyResult.payload?.data?.status === true) {
    //                         toast.success(verifyResult.payload?.data?.message || 'Payment verified successfully!', {
    //                             position: "bottom-right",
    //                             closeOnClick: true
    //                         });
    //                         // Refresh link list after successful payment verification
    //                         // await dispatch(linkList());
    //                         // Navigate to short-links page after successful payment
    //                         // navigate('/short-links');
    //                         localStorage.setItem('biolink_status', 'paid');
    //                         setBool(!bool)
    //                         setShow2(false);
    //                     } else {
    //                         const errorMessage = verifyResult.payload?.data?.message || 'Payment verification failed';
    //                         toast.error(errorMessage, { position: "bottom-right" });
    //                     }
    //                 } catch (error) {
    //                     console.error('Error verifying payment:', error);
    //                     toast.error('Error verifying payment. Please contact support.', { position: "bottom-right" });
    //                 }
    //             },
    //             prefill: {
    //                 name: user?.name || user?.user?.name || '',
    //                 email: user?.email || user?.user?.email || '',
    //                 contact: user?.phone || user?.user?.phone || user?.contact || '',
    //             },
    //             notes: {
    //                 plan_id: item.id,
    //                 plan_name: item.plan_name || item.name,
    //             },
    //             theme: {
    //                 color: '#667eea'
    //             },
    //             modal: {
    //                 ondismiss: function () {
    //                     console.log('Payment modal closed');
    //                 }
    //             }
    //         };

    //         const razorpay = new window.Razorpay(options);
    //         razorpay.open();

    //         razorpay.on('payment.failed', function (response) {
    //             console.error('Payment failed:', response.error);
    //             toast.error('Payment failed. Please try again.', { position: "bottom-right" });
    //         });
    //     } catch (error) {
    //         console.error('Error creating order:', error);
    //         toast.error('An error occurred. Please try again.', { position: "bottom-right" });
    //     }
    // };

      const checkoutPage = (data) => {
        navigate('/checkout-page', { state: { data,subscription_plan:true } });
    };


    return (
        <>
            <Modal show={show2} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Subscription</Modal.Title>
                </Modal.Header>
                <Modal.Body className='p-5'>
                    {loader ?
                        <Loader />
                        : data ?
                            <div className="plan-card">
                                <div className="d-flex align-items-center gap-2 plan-card-header d-flex justify-content">
                                    <h6 className="plan-title">{data.plan_name || data.name || 'Plan'}</h6>

                                </div>
                                <div className="plan-card-body">
                                    <div className="plan-field">
                                        <label>Price:</label>
                                        <div className="plan-price-container">
                                            {data.mrp && parseFloat(data.mrp) > 0 && parseFloat(data.price) < parseFloat(data.mrp) && (
                                                <span className="plan-mrp">
                                                    {data.currency || '₹'}{data.mrp}
                                                </span>
                                            )}
                                            <p className={`plan-value price-value ${(() => {
                                                const price = parseFloat(data.price) || 0;
                                                return price === 0 ? 'price-free' : '';
                                            })()}`}>
                                                {(() => {
                                                    const price = parseFloat(data.price) || 0;
                                                    if (price === 0) {
                                                        return 'Free';
                                                    }
                                                    const [intPart, decPart] = String(data.price).split('.');
                                                    return (
                                                        <>
                                                            {data.currency || '₹'}{intPart}
                                                            {decPart ? <span style={{ fontSize: '0.6em' }}>.{decPart}</span> : null}
                                                            <span style={{ fontSize: '0.6em' }}> INR</span>
                                                        </>
                                                    );
                                                })()}
                                            </p>
                                        </div>
                                        {(parseFloat(data.price_usd) > 0 || parseFloat(data.mrp_usd) > 0) && (
                                            <div className="plan-price-container mt-1">
                                                {data.mrp_usd && parseFloat(data.mrp_usd) > 0 && parseFloat(data.price_usd) < parseFloat(data.mrp_usd) && (
                                                    <span className="plan-mrp">
                                                        ${data.mrp_usd}
                                                    </span>
                                                )}
                                                <p className="plan-value price-value">
                                                    {(() => {
                                                        const [intPart, decPart] = String(data.price_usd ?? '').split('.');
                                                        return (
                                                            <>
                                                                ${intPart}
                                                                {decPart ? <span style={{ fontSize: '0.6em' }}>.{decPart}</span> : null}
                                                                <span style={{ fontSize: '0.6em' }}> USD</span>
                                                            </>
                                                        );
                                                    })()}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                    {data.description && (
                                        <div className="plan-field">
                                            <label>Description:</label>
                                            <p className="plan-value">{data.description}</p>
                                        </div>
                                    )}

                                    {(data.days_validity || data.validity_days || data.validity || data.days) && (
                                        <div className="plan-field">
                                            <label>Days Validity:</label>
                                            <p className="plan-value validity-days">
                                                {(() => {
                                                    const days = data.days_validity || data.validity_days || data.validity || data.days;
                                                    return `${days} ${days === 1 ? 'day' : 'days'}`;
                                                })()}
                                            </p>
                                        </div>
                                    )}

                                </div>
                                <div className="plan-card-footer">
                                    {/* {isFreePlan(item) ? (
                                            <button
                                                className="btn-plan-action btn-current"
                                                disabled
                                            >
                                                Current Plan
                                            </button>
                                        ) : ( */}
                                    <button
                                        className="btn-plan-action btn-buy"
                                        onClick={() => 
                                            // handleBuyPlan(data)
                                              checkoutPage(data)
                                        }
                                    >
                                        Buy Plan
                                    </button>
                                    {/* )} */}
                                </div>
                            </div>
                            :
                            <div className='text-center no-data'>No plans found</div>
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}
